import clamp from 'lodash-es/clamp';
export function range(min, max) {
  if (min === void 0) {
    min = -Infinity;
  }

  if (max === void 0) {
    max = Infinity;
  }

  return function (proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
      get: function get() {
        return this[alias];
      },
      set: function set(val) {
        Object.defineProperty(this, alias, {
          value: clamp(val, min, max),
          enumerable: false,
          writable: true,
          configurable: true
        });
      },
      enumerable: true,
      configurable: true
    });
  };
}